/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetPastActionsForResourceQuery,
  PastActionsForResourceSortInput,
  PastActionsForResourceFilterInput,
  FutureActionsForResourceSortInput,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  resourceId: string;
  page: string;
  limit: string;
  sort?: PastActionsForResourceSortInput | FutureActionsForResourceSortInput;
  filter?: PastActionsForResourceFilterInput;
  skip?: boolean;
};

export function useGetPastActionsForResource({
  resourceId,
  page,
  limit,
  sort,
  filter,
  skip,
}: Props) {
  const {
    data: result,
    loading,
    error,
  } = useGetPastActionsForResourceQuery({
    variables: {
      resourceId,
      page: Number(page),
      limit: Number(limit),
      sort: sort as PastActionsForResourceSortInput,
      filter,
    },
    onError(err) {
      showError(err.message);
    },
    skip,
  });

  const data = result?.pastActionsForResource?.result ?? [];
  const count = result?.pastActionsForResource.pageInfo.count ?? 0;

  return { data, loading, count, error } as const;
}
